import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  id: "app"
};
const _hoisted_2 = {
  class: "info-text"
};
const _hoisted_3 = ["href"];

const _hoisted_4 = /*#__PURE__*/_createTextVNode("❮ ❮ Vissza az összes kérdéshez");

const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

const _hoisted_7 = [_hoisted_4, _hoisted_5, _hoisted_6];

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Nyomd meg a kérdőjelet, és kapd meg a választ a kérdésre! Oldalra swipe-olva több kérdést találsz. A kisorsolt válaszra kattintva hasznos dolgok nyílnak meg.");

const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

const _hoisted_11 = /*#__PURE__*/_createTextVNode(" A random megjelenő válaszok gyűjteménye ");

const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://gist.github.com/lapaj/61ddd2a5003cc84aef1c169e89bf399d",
  target: "_blank"
}, "itt található.", -1);

const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Az app innen szedi a kisorsolt válaszokat, a gist-et átírva lehet hozzáadni vagy törölni is azokból, amik megjelennek. Éttermeket a pofijanika_eats, kávézókat a pofijanika_latteart szakértői accountokról gyűjtöttem.");

const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Egy-egy kérdés külön is megosztható/megnyitható ilyen speciális linkekkel: ");

const _hoisted_17 = ["href", "onClick"];
const _hoisted_18 = {
  class: "random-result-container"
};
const _hoisted_19 = ["href", "innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_overlay = _resolveComponent("van-overlay");

  const _component_QuestionRandomizer = _resolveComponent("QuestionRandomizer");

  const _component_van_swipe_item = _resolveComponent("van-swipe-item");

  const _component_van_swipe = _resolveComponent("van-swipe");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_icon, {
    name: "info",
    class: "info-button",
    onClick: _cache[0] || (_cache[0] = $event => $data.showInfo = true)
  }), _createVNode(_component_van_overlay, {
    show: $data.showInfo,
    onClick: _cache[1] || (_cache[1] = $event => $data.showInfo = false)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", null, [$options.filteredQuestions.length == 1 ? (_openBlock(), _createElementBlock("a", {
      key: 0,
      href: $options.origin
    }, _hoisted_7, 8, _hoisted_3)) : _createCommentVNode("", true), _hoisted_8, _hoisted_9, _hoisted_10, _hoisted_11, _hoisted_12, _hoisted_13, _hoisted_14, _hoisted_15, _hoisted_16, _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questions, q => {
      return _openBlock(), _createElementBlock("li", {
        key: q.filename
      }, [_createElementVNode("a", {
        href: $options.getQuestionURL(q),
        onClick: _withModifiers($event => $options.goToQuestionURL(q), ["prevent"])
      }, _toDisplayString($options.getQuestionURL(q)), 9, _hoisted_17)]);
    }), 128))])])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_overlay, {
    show: $data.showDisplay,
    onClick: _cache[2] || (_cache[2] = $event => $options.closeDisplay())
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createElementVNode("a", {
      class: _normalizeClass(['random-result', {
        animate: $data.showAnimation
      }]),
      href: $data.linkPrefix ? $data.linkPrefix + $data.displayedItem : '',
      innerHTML: $data.displayedItem,
      target: "_blank"
    }, null, 10, _hoisted_19)])]),
    _: 1
  }, 8, ["show"]), $options.filteredQuestions.length > 1 && !$data.showInfo ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "prev-button",
    onClick: _cache[3] || (_cache[3] = $event => $options.prev())
  }, [_createVNode(_component_van_icon, {
    name: "arrow-left"
  })])) : _createCommentVNode("", true), $options.filteredQuestions.length > 1 && !$data.showInfo ? (_openBlock(), _createElementBlock("button", {
    key: 1,
    class: "next-button",
    onClick: _cache[4] || (_cache[4] = $event => $options.next())
  }, [_createVNode(_component_van_icon, {
    name: "arrow"
  })])) : _createCommentVNode("", true), _createVNode(_component_van_swipe, {
    class: "swiper",
    "show-indicators": false,
    ref: "swiper"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredQuestions, (question, i) => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: i
      }, {
        default: _withCtx(() => [_createVNode(_component_QuestionRandomizer, {
          question: question.prompt,
          "image-url": question.imageUrl,
          items: question.items,
          "link-prefix": question.linkprefix,
          onShowDisplay: _cache[5] || (_cache[5] = $event => $data.showDisplay = true),
          onDisplayItem: $options.displayItem,
          onShowAnimation: _cache[6] || (_cache[6] = $event => $data.showAnimation = true),
          onCycling: $options.setStayShown
        }, null, 8, ["question", "image-url", "items", "link-prefix", "onDisplayItem", "onCycling"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 512)]);
}